// extracted by css-extract-rspack-plugin
export default {"rows":"UHDvJBPWPYUeOgtb"};